import {FormGroup} from "@angular/forms";
import {DataPersonalSellerPf} from "../shared/models/SellerPf.model";
import {SellerPJDataPayload} from "../shared/models/sellerPj.model";

export function patchFormWithNestedObject(formGroup: FormGroup, data: DataPersonalSellerPf | SellerPJDataPayload): void {
  Object.keys(formGroup.controls).forEach(controlName => {
    const value = getValueByPath(data, controlName);
    if (value !== undefined) {
      formGroup.get(controlName)?.patchValue(value);
    }
  });
}

function getValueByPath(obj: any, path: string): any {
  const keys = path.split('_');
  return keys.reduce((acc, key) => acc && acc[key], obj);
}
